<div id="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" style="align-self: center">
    <app-modal-loader [modalIdSubject]="this.modalId" style="width: inherit; display: none"></app-modal-loader>
  </div>
</div>
